var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getMessage)?_c('h4',{staticClass:"spinner__message"},[_vm._v(" "+_vm._s(_vm.getMessage)+" ")]):_vm._e(),_c('vue-spinner',{attrs:{"color":"#1d2b4e"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }